// removed by extract-text-webpack-plugin
module.exports = {"buttons":"share-url-modal__buttons___2LGAy","copy-button":"share-url-modal__copy-button___1BmVE","link":"share-url-modal__link___SO6eC"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/share-url-modal.scss
// module id = 1333
// module chunks = 0